import * as React from 'react';

export interface SelectOption {
    id: string;
    name: string;
}

interface Props {
    id: string;
    value: string;
    className?: string;
    placeholder?: string;
    options: SelectOption[];
    isDisabled?: boolean;
    onChange: (event: React.ChangeEvent<HTMLSelectElement>) => void;
}

export const Select = ({ id, value, className, placeholder = 'Select an option', options, isDisabled = false, onChange }: Props) => {
    return (
        <select className={`${className}-input ${className}-${id}`} id={id} value={value} onChange={onChange} disabled={isDisabled}>
            <option value='' disabled selected hidden>
                {placeholder}
            </option>
            {options.map(option => (
                <option key={option.id} value={option.id}>
                    {option.name}
                </option>
            ))}
        </select>
    );
};
